import React, { useMemo, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import useStore from 'store/AccountStore';
import OpSelect from 'op2mise-react-widgets/OpSelect/OpSelect';
import useSwitchOrganisation from 'hooks/useSwitchOrganisation';
import styles from './OrganisationSelect.module.css';

const ORGANISATION_FIELDS = { text: 'name', value: 'id' };
const NO_ORGANISATION_PLACEHOLDER = 'No organisation';

function OrganisationSelect() {
  const { user } = useStore((state) => state);
  const { isSwitching, requestSwitchAsync } = useSwitchOrganisation();
  // Changing the key remounts the dropdown so it shows the current organisation again
  const [selectKey, setSelectKey] = useState(0);

  const organisations = useMemo(
    () =>
      (user?.organisations ?? []).map((org) => ({
        id: org.organisationId,
        name: org.name,
      })),
    [user?.organisations]
  );

  const handleChangeAsync = async (organisation) => {
    const didHandle = await requestSwitchAsync(organisation);
    if (!didHandle) setSelectKey((key) => key + 1);
  };

  return (
    <div className={styles.organisationSelect}>
      <label>Organisation:</label>
      <OpSelect
        key={selectKey}
        dataSource={organisations}
        enabled={!isSwitching}
        fields={ORGANISATION_FIELDS}
        onChange={(e) => {
          handleChangeAsync(e.target.itemData);
        }}
        placeholder={NO_ORGANISATION_PLACEHOLDER}
        value={user?.organisationId ?? null}
        width={200}
      />
      {isSwitching && (
        <Spinner
          animation="border"
          aria-label="Switching organisation"
          className={styles.spinner}
          role="status"
          size="sm"
        />
      )}
    </div>
  );
}

export default OrganisationSelect;
